import { MST1030_R01Dto } from './Dto_MST1030_R01';

export const flattenTreeForDisplay = (
    treeRoots: MST1030_R01Dto[],
    treeDirection: 'forward' | 'reverse' = 'forward'
): MST1030_R01Dto[] => {
    const result: MST1030_R01Dto[] = [];
    let valueIndex = 0;
    const isReverse = treeDirection === 'reverse';

    const flattenRecursive = (nodes: MST1030_R01Dto[], level: number) => {
        for (const node of nodes) {
            const displayItemCd = (isReverse && level > 0)
                ? node.prntItemcd
                : node.childItemcd;
            const displayItemNm = (isReverse && level > 0)
                ? node.prntItemnm
                : node.childItemnm;

            const flatNode: MST1030_R01Dto = {
                ...node,
                itemCd: displayItemCd,
                itemNm: displayItemNm,
                level,
                hasChildren: node.children ? node.children.length > 0 : false,
                valueIndex: valueIndex++,
                children: undefined,
            };
            result.push(flatNode);

            if (node.children && node.children.length > 0) {
                flattenRecursive(node.children, level + 1);
            }
        }
    };

    flattenRecursive(treeRoots, 0);
    return result;
};
